import { render, staticRenderFns } from "./Top3.vue?vue&type=template&id=17a42fa8&scoped=true"
import script from "./Top3.vue?vue&type=script&lang=js"
export * from "./Top3.vue?vue&type=script&lang=js"
import style0 from "./Top3.vue?vue&type=style&index=0&id=17a42fa8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a42fa8",
  null
  
)

export default component.exports